import React from 'react';

const PageLoader = ({ fullScreen = true, opacity = 90 }) => {
  const containerClass = fullScreen 
    ? "fixed inset-y-0 right-0 z-[9999]" 
    : "absolute inset-0 z-[50] rounded-2xl min-h-[400px]";

  const style = fullScreen ? { left: 'var(--sidebar-width, 0)' } : {};

  return (
    <div 
      className={`${containerClass} flex items-center justify-center pointer-events-none select-none`}
      style={style}
    >
   
      <div className={`absolute inset-0 bg-white/${opacity} backdrop-blur-xl transition-all duration-700`} />
      
      <div className="relative flex flex-col items-center justify-center">
        
        <div className="w-48 h-28 sm:w-64 sm:h-40 relative flex items-center justify-center overflow-hidden">
          <svg 
            viewBox="0 0 400 200" 
            className="w-full h-full opacity-90"
            preserveAspectRatio="xMidYMid meet"
          >
            <defs>
              <filter id="glow-green">
                <feGaussianBlur stdDeviation="3" result="blur"/>
                <feComposite in="SourceGraphic" in2="blur" operator="over"/>
              </filter>
              <filter id="glow-red">
                <feGaussianBlur stdDeviation="3" result="blur"/>
                <feComposite in="SourceGraphic" in2="blur" operator="over"/>
              </filter>
            </defs>

            {/* Bull Move (Green) */}
            <path
              d="M0,150 L40,130 L80,140 L120,60"
              fill="none"
              stroke="#10b981"
              strokeWidth="5"
              strokeLinecap="round"
              className="chart-segment segment-1"
              filter="url(#glow-green)"
            />

            {/* Bear Move (Red) */}
            <path
              d="M120,60 L160,110 L200,90 L240,140"
              fill="none"
              stroke="#ef4444"
              strokeWidth="5"
              strokeLinecap="round"
              className="chart-segment segment-2"
              filter="url(#glow-red)"
            />

            {/* Final Rally (Green) */}
            <path
              d="M240,140 L280,80 L320,100 L360,40 L400,60"
              fill="none"
              stroke="#10b981"
              strokeWidth="5"
              strokeLinecap="round"
              className="chart-segment segment-3"
              filter="url(#glow-green)"
            />

            {/* Price Indicator Dot */}
            <circle r="8" fill="#10b981" className="price-dot shadow-lg">
              <animateMotion
                dur="2s"
                repeatCount="indefinite"
                path="M0,150 L40,130 L80,140 L120,60 L160,110 L200,90 L240,140 L280,80 L320,100 L360,40 L400,60"
              />
            </circle>
          </svg>
        </div>

        {/* Minimalist Data Loading Indicator */}
        <div className="mt-4 flex items-center gap-2">
          <div className="flex gap-1">
             <div className="w-1 h-3 bg-emerald-500 rounded-full animate-[bounce_1s_infinite_0s]" />
             <div className="w-1 h-5 bg-emerald-400 rounded-full animate-[bounce_1s_infinite_0.1s]" />
             <div className="w-1 h-2 bg-red-400 rounded-full animate-[bounce_1s_infinite_0.2s]" />
             <div className="w-1 h-4 bg-emerald-500 rounded-full animate-[bounce_1s_infinite_0.3s]" />
          </div>
        </div>
      </div>

      <style dangerouslySetInnerHTML={{ __html: `
        .chart-segment {
          stroke-dasharray: 500;
          stroke-dashoffset: 500;
          animation: draw-market 2s linear infinite;
        }

        .segment-1 { animation-delay: 0s; }
        .segment-2 { animation-delay: 0s; }
        .segment-3 { animation-delay: 0s; }

        @keyframes draw-market {
          0% { stroke-dashoffset: 500; opacity: 0; }
          10% { opacity: 1; }
          90% { opacity: 1; }
          100% { stroke-dashoffset: 0; opacity: 0; }
        }

        .price-dot {
          filter: drop-shadow(0 0 8px rgba(16, 185, 129, 0.4));
        }
      `}} />
    </div>
  );
};

export default PageLoader;
